export const availableSteps: string[] = [
  "Comprobar cobertura",
  "Seleccionar Servicios",
  "Resumen de contratación",
  "Datos de contrato",
  "Adjuntar Documentos",
];
